import React from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../../components/admin/Sidebar';
import Header from '../../components/admin/Header';
import '../../global.css';
import loaderImg from '../../images/loader.gif';
import { selectIsLoading } from '../../redux/loadingSlice';

const Layout = ({ children }) => {
  const isLoading = useSelector(selectIsLoading);  
    
  return (
    <div className="dashboard-container flex">
      <div className="container-fluid h-100">
        <div className="row h-100 overflow-auto main-wrap-row">
          <Sidebar />
          <main className="col px-0 h-100 main-wrap">
            <Header />
            <LoadingOverlay />
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

const LoadingOverlay = () => {
  const isLoading = useSelector(selectIsLoading);
  if (!isLoading) return null;
  return (
    <div style={overlayStyle}>
      <img src={loaderImg} alt="Loading..." style={loaderImageStyle} />
    </div>
  );
};

const overlayStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 100000,
};

const loaderImageStyle = {
  width: '360px',
  height: '250px',
};

export default Layout;